import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../tables';

// teamId addresses a team directly, e.g. one the user is about to lead
type Arguments = { teamId: string; teamLeaderId?: undefined } | { teamId?: undefined; teamLeaderId: string };

export const schemaUserResolver_GetAdvisersByTeam = z.array(
    UsersTableDefinitionZod.pick({
        assignable: true,
        buckets: true,
        deactivated: true,
        delegateId: true,
        firstName: true,
        id: true,
        lastName: true,
        role: true,
    }).merge(
        z.object({
            locked: z.boolean(),
        }),
    ),
);

export type SchemaUserResolver_GetAdvisersByTeam = z.infer<typeof schemaUserResolver_GetAdvisersByTeam>;

export type UserResolver_GetAdvisersByTeam = Resolver<Arguments, SchemaUserResolver_GetAdvisersByTeam>;
